import { Flex } from 'antd';
import styled from 'styled-components';

export const Wrapper = styled.div`
  gap: 24px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: center;
  width: 100%;
  @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
    flex-direction: row;
    & > * {
      width: 50%;
    }
  }
`;

export const FinishDateWrapper = styled(Flex)`
  border-radius: 4px;
  padding: 24px;
  background: ${({ theme }) => theme.colors.white};
  width: 100%;
  & > span {
    padding: 3px;
    border-radius: 4px;
    height: min-content;
    background: ${({ theme }) => theme.colors.purple2};
    border: 1px solid ${({ theme }) => theme.colors.purple3};
  }
`;

export const TextWrapper = styled(Flex)`
  gap: 8px;
`;

export const RecommendationWrapper = styled(Flex)`
  border-radius: 4px;
  padding: 24px;
  background: ${({ theme }) => theme.colors.white};
  width: 100%;
  & > span {
    padding: 3px;
    border-radius: 4px;
    height: min-content;
    background: ${({ theme }) => theme.colors.purple2};
    border: 1px solid ${({ theme }) => theme.colors.purple3};
  }
`;

export const TitleWrapper = styled.span`
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  color: ${({ theme }) => theme.colors.black9};
`;

export const ContentWrapper = styled.span`
  font-size: 18px;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: -0.2px;
  color: ${({ theme }) => theme.colors.black9};
`;
